export const ROUTES = {
  NOWHERE: "#",
  DASHBOARD: "",
  ORGANIZATION: "/org/:orgId",
  STUDENTS: "students",
  STUDENT_PROFILE: "students/:studentId",
  RISE: {
    BASE: "rise",
    STRATEGY: "strategy",
    IMPACT: "impact",
  },
  ANALYTICS: {
    BASE: "analytics",
    FUNNEL: "funnel",
    ADOPTION: "adoption",
    ENGAGEMENT_DATA: "engagement-data",
    ENGAGEMENT_INDEX: "commitment-index",
    PREDICTIVE_MODELS: "predictive-models",
    APPLY_INDEX: "apply-index",
    COMMIT_INDEX: "commit-index",
    MELT_INDEX: "melt-index",
    YIELD_INDEX: "yield-index",
    RETAIN_INDEX: "retain-index",
  },
  COMMUNITY_TOOLS: {
    BASE: "community-tools",
    OVERVIEW: "overview",
    GAMES_AND_LIVE_EVENTS: "games-and-live-events",
    BULK_MESSAGING: {
      BASE: "bulk-messaging",
      SEND_NOW: "send-now",
      BASIC_INFORMATION: "basic-information",
      COMPOSE_MESSAGE: "compose-message",
      REVIEW: "review",
      EDIT: "edit",
      DETAILS: "details",
      CAMPAIGN_DETAILS: "campaign-details",
      RESULTS: "results",
    },
    PEER_MESSAGING: "peer-messaging",
    COMPETITOR_MATCH: "competitor-match",
    DAB: "dynamic-action-button",
    FEED_POSTS: {
      BASE: "feed-posts",
      DETAILS: "details",
      RESULTS: "results",
    },
    EDIT_EVENT: "edit-event",
    LIVE_EVENT: "live-event",
    EVENT_DETAILS: {
      DETAILS: "details",
      RESULTS: "results",
    },
    GAME: "game",
  },
  COMMUNITY_MANAGEMENT: {
    BASE: "community-management",
    CHANNEL_REQUEST: "channel-request",
    MANAGE_CHANNELS: "manage-channels",
    MANAGE_TEAM: {
      BASE: "manage-team",
      SEND_INVITE: "send-invite",
      DETAILS: "details",
      ROLE: "role",
    },
    UPDATE_SCHOOL_PROFILE: "update-school-profile",
  },
  DATA_MANAGEMENT: {
    BASE: "data-management",
    FILE_STORAGE: "file-storage",
  },
  RESOURCES: "resources",
  SETTINGS: {
    BASE: "settings",
    MANAGE_ACCOUNTS: "manage-accounts",
    NOTIFICATION_SETTINGS: "notification-settings",
  },
  MANAGE_PROFILE: {
    BASE: "profile",
    YOUR_PROFILE: "your-profile",
    FUN_FACTS: "fun-facts",
    SOCIALS: "socials",
    CONTACT_INFO: "contact-info",
    NOTIFICATIONS: "notifications",
    PASSWORD: "password",
  },
  COMPONENTS: "components",
  CHAT: {
    INDEX: "chat",
    SELECTED_CHAT: "chat/:chat",
  },
  PUBLIC: {
    LOGIN: "login",
    FORGOT_PASSWORD: "forgot_password",
    RESET_PASSWORD: "reset_password",
    OTP_VERIFICATION: "otp_verification",
    ACCEPT_INVITE: "accept_invite/:inviteToken",
  },
};
